import { render, staticRenderFns } from "./Participant.vue?vue&type=template&id=3b5d1be4"
import script from "./Participant.vue?vue&type=script&lang=js"
export * from "./Participant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports